import React, { useEffect, useMemo, useState, useCallback } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTheme } from "../../../themes/theming";
import '../index.css';
import BootstrapTable from 'react-bootstrap-table-next';
import { fetchKaizenOverview } from "../../../actions/dashboardAction";
import FilterDropdown from "./filterComponent";
import { AUTO_DEFAULT_FILTER } from "../../../AppConstant";

const KaizenOverviewTable = (props) => {
    var I18n = require("react-redux-i18n").I18n;
    const { dispatch , dealerOperations} = props;
    const [data, setData] = useState([]);
    const [filterStatus, setFilterStatus] = useState(I18n.t('dashboardElements.NotStarted'))
    const [hasFetched, setHasFetched] = useState(false);

    const handleApplyFilters = (filters) => {
        setFilterStatus(filters[0]);
    };

    /** Memoize filtered data for performance and sorting */
    const filteredData = useMemo(() => {
        let filtered;

        if (filterStatus === I18n.t('dashboardElements.NotStarted')) {
            filtered = data?.filter(item => item?.kaizenStatus === null);
        } else if (filterStatus === I18n.t('dashboardElements.Ongoing')) {
            filtered = data?.filter(item => item?.kaizenStatus === "ONGOING");
        } else if (filterStatus === I18n.t('dashboardElements.Completed')) {
            filtered = data?.filter(item => item?.kaizenStatus === "COMPLETED" && item?.durationDays !== null && item?.durationDays !== undefined && item?.durationDays >= 0);
        }

        // Sort by firstAuditScore in descending order (highest first)
        return filtered?.sort((a, b) => b.firstAuditScore - a.firstAuditScore);
    }, [data, filterStatus]);


    const firstAuditScoreFormatter = (cell, row) => {
        if (row.firstAuditScore !== null && row.firstAuditScore !== undefined) {
            return Math.floor(row.firstAuditScore);
        }
        return "";
    };

    const dateFormatter = useCallback((cell, row) => {
        if (filterStatus === I18n.t('dashboardElements.NotStarted')) {
            return row?.delayDays !== null && row?.delayDays !== undefined ? `${row?.delayDays}` : "";
        } else if (filterStatus === I18n.t('dashboardElements.Ongoing')) {
            return row?.durationDays !== null && row?.durationDays !== undefined ? `${row?.durationDays}` : "";
        } else if (filterStatus === I18n.t('dashboardElements.Completed')) {
            return (row?.durationDays >= 0 ) && row?.durationDays !== undefined ? `${row?.durationDays}` : "";
        }
        return "";
    }, [filterStatus]);

    /** Handler for API success callback */
    const onSuccess = (response) => setData(response);;
    /** Handler for API failure callback */
    const onFailure = (error) => console.error("❌ Error while fetching list of video", error);

    const fetchProgressBarData = () => {
        try {
            if (!props.toolboxByType?.toolboxByType || props.toolboxByType.toolboxByType?.length === 0) {
                return;
            }

            const toolBoxList = props.toolboxByType?.toolboxByType;
            const cycleList = props.cycleDataList;

            if (!toolBoxList || toolBoxList.length === 0 || !cycleList || cycleList.length === 0) {
                console.warn("Required data is not ready yet.");
                return;
            }

            const initialToolBoxId = toolBoxList[toolBoxList.length - 1];
            const initialCycle = cycleList[cycleList.length - 1];

            if (!initialCycle?.cycle) {
                console.warn("Initial cycle format is missing.");
                return;
            }
            const [initialStartDate, initialEndDate] = initialCycle.cycle.split(" to ");
            const nmscCode = props.existingProps.userMdl.nmsc;
            const activeProgram = props.existingProps.userMdl.activeProgram;

            const data = {
                "userNmscCode": props.existingProps.userMdl.nmsc,
                "userLangCode": props.existingProps.userMdl.lang,
                "programList": [props.existingProps.userMdl.activeProgram],
                "nmscCode": props.existingProps.nmscFlag ? [nmscCode.toUpperCase()] : props.existingProps.nmscFilter,
                "brand": props.existingProps.brandFilter,
                "country": props.existingProps.countryFilter,
                "region": props.existingProps.regionFilter,
                "userId": props.existingProps.userMdl.username,
                "businessArea": props.existingProps.userMdl.businessAreaKey,
                "toolboxIDList": (props.existingProps.toolboxIDList?.length > 0) ? props.existingProps.toolboxIDList : [Number(initialToolBoxId?.packageMapPrimaryKey)],
                "startDate": props.existingProps.startDate !== "" ? props.existingProps.startDate : initialStartDate,
                "endDate": props.existingProps.endDate !== "" ? props.existingProps.endDate : initialEndDate,
                "dealerOperations": dealerOperations?.length > 0 ? dealerOperations : (AUTO_DEFAULT_FILTER[activeProgram] || ['All'])
            }
            dispatch(fetchKaizenOverview(onSuccess, onFailure, data))

        } catch (error) {
            console.error("Error fetching progress bar data:", error);
        }
    }


    useEffect(() => {
        const toolBoxReady = props.toolboxByType?.toolboxByType?.length > 0;
        const cycleReady = props.cycleDataList?.length > 0;

        if (toolBoxReady && cycleReady && !hasFetched) {
            fetchProgressBarData();
            setHasFetched(true);
        }
    }, [props.toolboxByType?.toolboxByType, props.cycleDataList, hasFetched]);

    // Dynamic header text based on filter status
    const getDynamicHeaderText = useCallback(() => {
        if (filterStatus === I18n.t('dashboardElements.NotStarted')) {
            return I18n.t('Table.Delays');
        } else if (filterStatus === I18n.t('dashboardElements.Ongoing')) {
            return I18n.t('Table.Duration');
        } else if (filterStatus === I18n.t('dashboardElements.Completed')) {
            return I18n.t('Table.Duration');
        }
    }, [filterStatus]);

    const columns = useMemo(() => [{
        dataField: 'dealerName',
        sort: true,
        text: I18n.t('Table.DelaerName'),
        style: { width: "4%", textAlign: "left", },
        headerStyle: { width: "4%", textAlign: "left", wordWrap: "break-word" }
    }, {
        dataField: 'dealerLocation',
        sort: true,
        text: I18n.t('Table.DealerLocation'),
        title: I18n.t('Table.DealerLocation'),
        formatter: null,
        style: { width: "3%", textAlign: "left", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
        headerStyle: { width: "4%", textAlign: "left", wordWrap: "break-word" }
    }, {
        dataField: 'nmsc',
        text: I18n.t('Table.nmsc'),
        sort: true,
        style: { width: "2%", textAlign: "center" },
        headerStyle: { width: "2%", textAlign: "center" },
    }, {
        dataField: 'firstAuditScore',
        text: I18n.t('Table.FirstAuditScore'),
        sort: true,
        formatter: firstAuditScoreFormatter,
        style: { width: "4%", textAlign: "center" },
        headerStyle: { width: "4%", textAlign: "center" , wordWrap: "break-word"},
    }, {
        dataField: filterStatus === I18n.t('dashboardElements.NotStarted') ? "delayDays" : "durationDays",
        text: getDynamicHeaderText(),
        sort: true,
        style: { width: "4%", textAlign: "center" },
        headerStyle: { 
            width: "3%", 
            textAlign: "center", 
            whiteSpace: "normal",
            wordWrap: "break-word"
        },
        order:'desc',
        formatter: dateFormatter,
    }], [dateFormatter, getDynamicHeaderText, firstAuditScoreFormatter, filterStatus]);

    return (
        <div style={{ minWidth: "100%" }}>
            <div className={"large-widget-header left-align-header widget-header-" + props.theme.name} title={I18n.t('dashboardHeaders.KaizenOverviewElement')}>
                {I18n.t('dashboard.KaizenOverview')}
                <FilterDropdown
                    options={[I18n.t('dashboardElements.NotStarted'), I18n.t('dashboardElements.Ongoing'), I18n.t('dashboardElements.Completed')]}
                    onApply={handleApplyFilters}
                    defaultSelected={[I18n.t('dashboardElements.NotStarted')]}
                    theme="dark"
                    icon="filter"
                    customClassName="widget-filter-menu-kaizen-overview"
                />
            </div>



            <div>
                {/* Sticky Header Section */}
                <div style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#fff", // important to avoid transparent background while scrolling
                    zIndex: 1,
                    padding: "10px 15px",
                    borderBottom: "1px solid #ccc",
                }}>
                    <p style={{
                        display: 'inline-block',
                        margin: 0,
                        marginRight: '13px',
                        border: "1px solid rgb(110 98 98)",
                        // padding: "2px 3px",
                        backgroundColor: "rgb(237 180 180)",
                        // fontWeight: 700,
                        width: '6.4rem',
                        paddingInline: '14px',
                        fontFamily: 'Arial, Helvetica, sans-serif',
                        fontSize: '13.5px',
                        display: "flex",
                        justifyContent: "center"
                    }}>
                        {filterStatus}
                    </p>
                </div>
                <div style={{ height: "580px", overflow: "scroll" }}>
                    <BootstrapTable
                        key={filterStatus} // Force re-render when filter changes
                        keyField='actionPlanId'
                        noDataIndication={I18n.t('tabsDetails.noActionAvailable')}
                        data={filteredData || []}
                        columns={columns}
                        hover
                        condensed
                        defaultSorted={[{
                            dataField: filterStatus === I18n.t('dashboardElements.NotStarted') ? "delayDays" : "durationDays",
                            order: 'desc' // highest to lowest
                        }]}
                    //rowEvents={rowEvents}
                    />
                </div>
            </div>
        </div>
    );
}
const mapStateToProps = state => {
    return {
        user: state.loginReducer,
        activityToolBox: state.activityReducer,
        cycleDataList: state.dashboardReducer.cycleDataList,
        toolboxByType: state.leftNavReducer
    };
};
export default withRouter(connect(mapStateToProps)(withTheme(KaizenOverviewTable)));

